import * as React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import { Box } from '@mui/material';
import Divider from '@mui/material/Divider';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { FE_APP_VERSION } from '../../../utils/config';
import MenuContent from './MenuContent';
import { useSelector } from 'react-redux';
import CognitoSignOutButton from '../../../components/widgets/CognitoSignoutButton';


// import CardAlert from './CardAlert';

function SideMenuMobile({ open, toggleDrawer }) {

  const user = useSelector((state) => state.auth.user) || null;
  const constants = useSelector(state => state?.constants?.data);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        [`& .${drawerClasses.paper}`]: {
          backgroundImage: 'none',
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Box sx={{pl: 2,pt: 2,  fontSize:'11px', color: '#444444'}}>UI version: {FE_APP_VERSION}</Box>
      <Box sx={{pl: 2,pt: 0,  fontSize:'11px', color: '#444444'}}>API version: {constants?.apiVersion}</Box>
      <Stack
        sx={{
          maxWidth: '70dvw',
          height: '100%',
        }}
      >
        <Stack direction="row" sx={{ p: 2, pb: 0, gap: 1 }}>
        { user && <Stack
            direction="row"
            sx={{ gap: 1, alignItems: 'center', flexGrow: 1, p: 1 }}
          >
            <Avatar
              sizes="small"
              alt={user.name}
              src="/static/images/avatar/7.jpg"
              sx={{ width: 36, height: 36 }}
            />
            <Box sx={{ mr: 'auto' }}>
              <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: '16px' }}>
                {user.name}
              </Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                {user.email}
              </Typography>
            </Box>
          </Stack> }
          
        </Stack>
        <Divider />
        <Stack sx={{ flexGrow: 1 }}>
          <MenuContent onClose={toggleDrawer(false)} />
          <Divider />
        </Stack>
        <Stack sx={{ p: 2 }}>
        { user && <CognitoSignOutButton className="mobile" /> }
        </Stack>
      </Stack>
    </Drawer>
  );
}

SideMenuMobile.propTypes = {
  open: PropTypes.bool,
  toggleDrawer: PropTypes.func.isRequired,
};

export default SideMenuMobile;
